module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Deadly Identity & Deadly Silence")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/HQ_CSS.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "conhead"
  }, [_c('i', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Cover_1"
    }
  }, [_c('i', [_vm._v("Deadly Identity")]), _c('br'), _vm._v(" By Lindsay McKenna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Cover_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Deadly Silence")]), _c('br'), _vm._v(" By Lindsay McKenna")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b6a414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 63
// module chunks = 0